import { Skeleton } from "@sentricmusic/ui";

export function CreateWriterModalSkeleton() {
  return (
    <div className="space-y-6">
      <div className="flex justify-start">
        <Skeleton className="h-12 w-48" />
      </div>
      <div className="flex justify-center">
        <Skeleton className="h-20 w-full" />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Skeleton className="h-9" />
        <Skeleton className="h-9" />
        <Skeleton className="h-9" />
        <Skeleton className="h-9" />
        <Skeleton className="h-9" />
        <Skeleton className="h-9" />
      </div>
      <div className="flex justify-between pt-2">
        <Skeleton className="h-9 w-20" />
        <Skeleton className="h-9 w-20" />
      </div>
    </div>
  );
}
